import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterMakelaarPage() {
  return <ClusterPageTemplate clusterName="Makelaar" sectorName="Makelaars & Vastgoed" sectorSlug="makelaars-vastgoed" heroTitle="Website laten maken voor een makelaar" heroDescription="Een premium website voor jouw makelaardij. Wij bouwen websites met een naadloze CRM-koppeling, prachtig woningaanbod en focus op leadgeneratie." websiteOnderdelen={[{
    icon: 'HomeIcon',
    title: 'Woningaanbod',
    description: 'Een overzichtelijke, visueel aantrekkelijke presentatie van je actuele aanbod met slimme filters.'
  }, {
    icon: 'TrendingUpIcon',
    title: 'Waardebepaling',
    description: 'Een speciale landingspagina gericht op het genereren van leads voor gratis waardebepalingen.'
  }, {
    icon: 'UsersIcon',
    title: 'Team & Kantoor',
    description: 'Makelaardij is mensenwerk. Stel je makelaars voor en laat zien waarom klanten voor jullie moeten kiezen.'
  }, {
    icon: 'BriefcaseIcon',
    title: 'Diensten',
    description: 'Heldere uitleg over jullie aanpak bij aankoop, verkoop, verhuur en taxaties.'
  }]} functionaliteiten={[{
    icon: 'LaptopIcon',
    title: 'CRM Koppeling',
    description: 'Automatische synchronisatie van je woningaanbod vanuit Realworks, Kolibri of een ander makelaars-CRM.'
  }, {
    icon: 'SearchIcon',
    title: 'Uitgebreide zoekfilters',
    description: 'Laat bezoekers eenvoudig zoeken op prijs, woonoppervlakte, locatie en woningtype.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Bezichtiging plannen',
    description: 'Geïntegreerde formulieren bij elke woning waarmee geïnteresseerden direct een bezichtiging kunnen aanvragen.'
  }]} siblingClusters={[{
    name: 'Projectontwikkelaar',
    slug: 'projectontwikkelaar'
  }, {
    name: 'Vastgoedbeheer',
    slug: 'vastgoedbeheer'
  }, {
    name: 'Woningpresentatie',
    slug: 'woningpresentatie'
  }]} faqs={[{
    q: 'Kunnen jullie koppelen met Realworks of Kolibri?',
    a: "Ja, wij hebben ervaring met het koppelen van websites aan de bekende makelaars-CRM systemen via API's of WonenWizards."
  }, {
    q: 'Wat kost een makelaarswebsite met CRM-koppeling?',
    a: 'Een basis website start vanaf €1.500. Voor een website inclusief automatische CRM-koppeling voor het woningaanbod maken we een offerte op maat, meestal tussen de €2.500 en €4.500.'
  }, {
    q: 'Hoe zorg ik voor meer verkoopopdrachten?',
    a: "We richten de website in met speciale 'funnels' en landingspagina's voor gratis waardebepalingen, gecombineerd met sterke lokale SEO."
  }, {
    q: 'Is het woningaanbod goed te bekijken op mobiel?',
    a: 'Absoluut. Meer dan 60% van de huizenzoekers gebruikt een smartphone. Onze websites en de fotogalerijen zijn 100% geoptimaliseerd voor mobiel gebruik.'
  }]} data-id="element-1087" />;
}